module.exports = __webpack_public_path__ + "stylesheets/section-vertical-text-video_f2175cd105430d23ddbe8f25633d91b5.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-vertical-text-video.less
// module id = MJwn
// module chunks = 151